<template>
  <with-root :show="teaching.url">
    <a class="card__link" :href="teaching.url" target="_blank">
      <card class="card--teaching"
        :horizontal="horizontal"
        :card-color="cardColor"
        :text-color="textColor"
        :accent-color="accentColor"
        :border-color="borderColor">
        <template v-slot:media v-if="toBase(teaching.image || placeholderImage)">
          <img
            class="card--teaching__image"
            :src="toBase(teaching.image || placeholderImage)"
            :alt="'Image ' + teaching.subject" />
        </template>
        <template v-slot:header>
          <h6 class="card--teaching__subject">{{ teaching.subject }}</h6>
        </template>
        <template v-slot:body>
          <div class="card--teaching__date">
            <p v-if="teaching.year" class="card--teaching__date__year">
              <span class="card--teaching__date__year__label">Year</span>: {{ teaching.year }}
            </p>
            <p v-if="teaching.semester" class="card--teaching__date__semester">
              <span class="card--teaching__date__semester__label">Semester</span>: {{ teaching.semester }}
            </p>
          </div>
          <p v-if="teaching.type" class="card--teaching__class-type">
            <span class="card--teaching__class-type__label">Class Type</span>: {{ teaching.type }}
          </p>
          <p v-if="teaching.course" class="card--teaching__courses">
            <span class="card--teaching__courses__label">Course</span>: {{ teaching.course }}
          </p>
        </template>
        <template v-slot:actions>
        </template>
      </card>
    </a>
  </with-root>
</template>

<script>
import { mapGetters } from 'vuex'

import Card from '@/components/Card'

export default {

  name: 'teaching-card',

  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    teaching: {
      type: Object,
      default: () => ({
        'subject': 'Teaching Subject',
        'course': 'Courses attending',
        'year': 'Year of class',
        'semester': 'Semester',
        'type': 'Type of class',
        'url': ''
      })
    },
    placeholderImage: {
      type: String
    }
  },

  components: {
    'card': Card
  },

  computed: {
    ...mapGetters(['toBase'])
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

a.card__link {
  display: flex;
  text-decoration: none;
  width: 100%;
}

.card--teaching {

  &__subject {
    font-size: 1.3rem;
    color: var(--text-color);
    min-height: 3.9rem;
  }

  &__date {
    display: flex;
    justify-content: space-between;

    &__year {
      &__label {
        font-weight: 700;
      }
    }

    &__semester {
      &__label {
        font-weight: 700;
      }
    }
  }

  &__courses {
    &__label {
      font-weight: 700;
    }
  }

  &__class-type {
    &__label {
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeachingCard.vue